<template lang="pug">
.report-area
    //- ModalSupervisor(
    //-         :available="showModal" 
    //-         title="REIMPRESIÓN DE DOCUMENTOS"  
    //-         @check-key="auth()"
    //-         confirmMessage="Autorizar Emisión de Reportes"
    //-         style="opacity: 0; position: fixed; top:0px; left:0px; margin-left: -1000px;"
    //-         @closed="$router.push('/')"
    //-     )
    v-toolbar(:color="colors.secondary" dark)
        v-icon insert_chart
        span.title Reportes {{branchOfficeName || ''}}
        v-btn(
            dark
            :color="colors.complement"
            style="position: absolute; right: 40px; top: 10px;"
            @click="getXLSX()"
            )
            v-icon(left) file_download
            span Descargar Reporte
    v-card()
        v-layout(wrap)
            v-flex.xs12.md6.px-3.pt-4
                v-menu(
                    :close-on-content-click="false"
                    :return-value="date"
                    lazy
                    transition="scale-transition"
                    offset-y
                    full-width
                    min-width="290px"
                    v-model="showCalendar"
                    )
                        template(slot="activator")
                            v-text-field.px-3(
                                outline
                                v-model="date"
                                readonly
                                )
                                div.formLabel(slot="prepend")
                                    span Fecha Inicio
                        v-date-picker(
                            v-model="date"
                            :color="colors.primary"
                            first-day-of-week="1"
                            locale="es"
                            )
            v-flex.xs12.md6.px-3.pt-4
                v-menu(
                    :close-on-content-click="false"
                    :return-value="date2"
                    lazy
                    transition="scale-transition"
                    offset-y
                    full-width
                    min-width="290px"
                    v-model="showCalendar2"
                    )
                        template(slot="activator")
                            v-text-field.px-3(
                                outline
                                v-model="date2"
                                readonly
                                )
                                div.formLabel(slot="prepend")
                                    span Fecha Fin
                        v-date-picker(
                            v-model="date2"
                            :color="colors.primary"
                            first-day-of-week="1"
                            locale="es"
                            )
            v-flex.xs12.md4.px-3.pt-4
                v-select.px-3(
                    :items="branchOfficeList"
                    item-text="name"
                    item-value="id"
                    placeholder="Sucursal"
                    v-model="branchOfficeSelected"
                    )
                    div.formLabel(slot="prepend")
                        span Sucursal
            v-flex.md6
            //- v-flex.xs12.px-3.pb-3
            //-     v-btn(
            //-         block
            //-         :color="colors.secondary"
            //-         dark
            //-         @click="fetchInformation()"
            //-         )
            //-         v-icon table
            //-         span Cargar Reporte
            v-flex.xs4.px-3
                v-btn(
                    :color="showing === 0 ? colors.complement : colors.primary"
                    @click="showing = 0"
                    block
                    dark) Reporte completo
            v-flex.xs4.px-3
                v-btn(
                    :color="showing === 1 ? colors.complement : colors.primary"
                    @click="showing = 1"
                    block
                    dark) Reporte boletas
            v-flex.xs4.px-3
                v-btn(
                    :color="showing === 2 ? colors.complement : colors.primary"
                    @click="showing = 2"
                    block
                    dark) Reporte Facturas
            v-flex.xs4.px-3
                v-btn(
                    :color="showing === 3 ? colors.complement : colors.primary"
                    @click="showing = 3"
                    block
                    dark) Reporte Transbank
            v-flex.xs4.px-3
                v-btn(
                    :color="showing === 4 ? colors.complement : colors.primary"
                    @click="showing = 4"
                    block
                    dark) Reporte Cheques
            v-flex.xs4.px-3
                v-btn(
                    :color="showing === 5 ? colors.complement : colors.primary"
                    @click="showing = 5"
                    block
                    dark) Reporte Crédito Cliente
            //v-flex.xs4.px-3
                v-btn(
                    :color="showing === 6 ? colors.complement : colors.primary"
                    @click="showing = 6"
                    block
                    dark) Reporte Consumo Interno
            v-flex.xs4.px-3
                v-btn(
                    :color="showing === 7 ? colors.complement : colors.primary"
                    @click="showing = 7"
                    block
                    dark) Reporte Venta Empleado
            v-flex.xs4.px-3
                v-btn(
                    :color="showing === 8 ? colors.complement : colors.primary"
                    @click="showing = 8"
                    block
                    dark) Reporte Nota de Crédito
            v-flex.xs4.px-3
                v-btn(
                    :color="showing === 9 ? colors.complement : colors.primary"
                    @click="showing = 9"
                    block
                    dark) Reporte Ingreso-Egreso
            v-flex.xs4.px-3
                v-btn(
                    :color="showing === 10 ? colors.complement : colors.primary"
                    @click="showing = 10"
                    block
                    dark) Reporte Vendedores Terreno
            v-flex.xs12.px-3.pb-3
                v-btn(
                    block
                    :color="colors.secondary"
                    dark
                    @click="fetchInformation()"
                    )
                    v-icon table
                    span Cargar Reporte
            v-flex.xs12
                v-data-table(
                    :items="showItems"
                    :headers="headers"
                    :rows-per-page-items="[25, 50, 100]" 
                )
                    template(slot="items" slot-scope="props")
                        td(
                            v-for="header in iterator"
                        )
                            span    {{props.item[header]}}
</template>

<script>
import reports from './reports.js'
export default reports
</script>

<style>

</style>
